import { __assign } from "tslib";
import { zipObject, reduce } from 'lodash';
import { blogLanguagesWithRtl as languages } from '@wix/communities-blog-universal/dist/src/constants/blog-languages';
export var DATE_LOCALES = __assign(__assign({}, zipObject(languages, languages)), { tl: 'tl-ph', zh: 'zh-tw', no: 'nb' });
var DEFAULT_DATE_FORMAT = 'MMM D';
export var DATE_FORMATS = __assign(__assign({}, reduce(languages, function (acc, value) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[value] = DEFAULT_DATE_FORMAT, _a)));
}, {})), { ko: 'MMM D일', ja: 'MMMDo' });
